import React from 'react';
import {
  Option,
  AfterSubmitFunc,
  FormTemplate,
  CheckboxGroup,
  LoadingAnimation,
} from 'ui-builder';
import { useDataLoaderNew } from 'data-loader';
import { IconButton, IconType } from '../../IconButton';
import { usePopupFormManager } from '../../PopupForm';

export function EditGridColumnsForm(
  props: {
    getValue: () => number[],
    setValue: (value: number[]) => Promise<void>,
    getOptionsFunc: () => Promise<Option<number>[]>,
    getTitle: () => string,
    afterSubmitFunc?: AfterSubmitFunc,
  },
) {
  const { data: options } = useDataLoaderNew(props.getOptionsFunc);

  const optionsGroups = options?.reduce((acc, option) => {
    const groupName = option.group || 'default';
    if (!acc[groupName]) {
      acc[groupName] = [];
    }
    acc[groupName].push(option);
    return acc;
  }, {} as Record<string, Option[]>) || {};

  return (
    <FormTemplate<{ ids: number[] }>
      title={props.getTitle()}
      getDataFunc={async () => ({
        ids: props.getValue(),
      })}
      submitFormFunc={async (data) => {
        await props.setValue(data.ids);

        return data;
      }}
      afterSubmitFunc={props.afterSubmitFunc}
    >
      {
        Object
          .entries(optionsGroups)
          .map(([groupName, groupOptions]) => (
            <CheckboxGroup
              key={groupName}
              options={groupOptions}
              source="ids"
              label={groupName}
              boldLabel
              hideLabel={Object.keys(optionsGroups).length === 1}
            />
          ))}

      {!options && (<LoadingAnimation />)}
    </FormTemplate>
  );
}

export function EditGridColumnsButton(
  props: {
    getValue: () => number[],
    setValue: (value: number[]) => Promise<void>,
    getOptionsFunc: () => Promise<Option<number>[]>,
    getTitle: () => string,
    className?: string,
  },
) {
  const popupManager = usePopupFormManager();

  return (
    <IconButton
      className={props.className}
      type={IconType.GEAR}
      title="Update Columns"
      onClick={() => {
        popupManager.openForm(
          <EditGridColumnsForm
            getValue={props.getValue}
            setValue={props.setValue}
            getOptionsFunc={props.getOptionsFunc}
            getTitle={props.getTitle}
          />,
        );
      }}
    />
  );
}
